/* tslint:disable */
import {
  App
} from '../index';

declare var Object: any;
export interface NotificationInterface {
  createdby?: string;
  notificationid?: string;
  state?: string;
  from: string;
  lastupdatedby?: string;
  profile: string;
  message: string;
  title?: string;
  targets: Array<string>;
  id?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  app?: App;
}

export class Notification implements NotificationInterface {
  createdby: string;
  notificationid: string;
  state: string;
  from: string;
  lastupdatedby: string;
  profile: string;
  message: string;
  title: string;
  targets: Array<string>;
  id: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  app: App;
  constructor(data?: NotificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Notification`.
   */
  public static getModelName() {
    return "Notification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Notification for dynamic purposes.
  **/
  public static factory(data: NotificationInterface): Notification{
    return new Notification(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Notification',
      plural: 'notifications',
      properties: {
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        notificationid: {
          name: 'notificationid',
          type: 'string'
        },
        state: {
          name: 'state',
          type: 'string',
          default: 'pending'
        },
        from: {
          name: 'from',
          type: 'string',
          default: 'system'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        profile: {
          name: 'profile',
          type: 'string'
        },
        message: {
          name: 'message',
          type: 'string'
        },
        title: {
          name: 'title',
          type: 'string'
        },
        targets: {
          name: 'targets',
          type: 'Array&lt;string&gt;'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Notification.ts